var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import throttle from 'raf-throttle';

var OnWidth = function (_PureComponent) {
  _inherits(OnWidth, _PureComponent);

  function OnWidth() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OnWidth);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnWidth.__proto__ || Object.getPrototypeOf(OnWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: window.innerWidth
    }, _this.update = throttle(_this.update), _this.update = function () {
      _this.setState({
        width: window.innerWidth
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OnWidth, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.update);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.update);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.state.width);
    }
  }]);

  return OnWidth;
}(PureComponent);

OnWidth.propTypes = {
  children: PropTypes.func.isRequired
};
export default OnWidth;